import {delay} from '@@/js/utils/delay';

const cartClass = '.main-cart'
const counter = '[data-cart-count]'
const removeClass = '.remove'
const formClass = '.woocommerce-cart-form'
const cart = document.querySelector(cartClass);

const openCart = () => document.body.classList.add('cart-is-open');

// The cart page redirects to the home page with #cart (app/includes/woocommerce.php): open the side cart, then drop the hash.
if (cart && window.location.hash === '#cart') {
  openCart();
  history.replaceState(null, '', window.location.pathname + window.location.search);
}

const pushGtmEvent = (event) => {
  if (typeof gtm4wp_datalayer_name === 'undefined' || !window[gtm4wp_datalayer_name]) return;
  window[gtm4wp_datalayer_name].push(event);
}

// GTM4WP adds the product data, including a numeric price, to the remove link
const getGtmProductData = link => {
  try {
    return JSON.parse(link.dataset.gtm4wp_product_data || '{}');
  } catch {
    return {};
  }
}

document.addEventListener('click', e => {
  const link = e.target.closest(removeClass);
  if (link) {
    e.preventDefault()
    const item = link.closest('.main-cart__item');
    const productData = item ? {
      name: item.querySelector('.main-cart__item-name a')?.innerText?.trim(),
      price: getGtmProductData(link).price,
      quantity: item.querySelector('.qty')?.value,
    } : {};
    removeItem(link.href, productData);
  }
})

const updateCounter = (html) => {
  const count = html.querySelector(counter).innerHTML;
  document.querySelector(counter).innerHTML = count;
}

const removeItem = (url, productData = {}) => {
  document.body.classList.add('is-cart-loading');
  fetch(url, {
    method: 'POST',
  })
  .then(response => response.text())
  .then(data => {
    const parser = new DOMParser().parseFromString(data, 'text/html');
    cart.innerHTML = parser.querySelector(cartClass).innerHTML;
    updateCounter(parser);
    pushGtmEvent({
      'event': 'gtm4wp.removeFromCartEEC',
      'ecommerce': {
        'currencyCode': typeof gtm4wp_currency !== 'undefined' ? gtm4wp_currency : 'AUD',
        'remove': {
          'products': [{
            'name': productData.name,
            'price': productData.price,
            'quantity': productData.quantity,
          }]
        }
      }
    });
  })
  .catch(error => {
    console.error(error);
  }).finally(() => {
    document.body.classList.remove('is-cart-loading');
  });
}

const updateCart = () => {
  const cartForm = document.querySelector(formClass);
  const formData = new FormData(cartForm);
  formData.append('update_cart', true);
  document.body.classList.add('is-cart-loading');

  fetch(`/`, {
    method: 'POST',
    body: formData,
  })
  .then(response => response.text())
  .then(data => {
    const parser = new DOMParser().parseFromString(data, 'text/html');
    cart.innerHTML = parser.querySelector(cartClass).innerHTML;
    updateCounter(parser);
    pushGtmEvent({
      'event': 'gtm4wp.cartUpdate',
    });
  })
  .catch(error => {
    console.error(error);
  }).finally(() => {
    document.body.classList.remove('is-cart-loading');
  });
}

const addToCart = (id, quantity, params) => {
  // Callers on product pages are covered by their own .is-cart-loading styles, but the ones on
  // content pages are not, so the re-entrancy guard belongs here with the flag it reads.
  if (document.body.classList.contains('is-cart-loading')) return;

  document.body.classList.add('is-cart-loading');
  const url = new URLSearchParams({
    'add-to-cart': id,
    quantity,
  }).toString();
  fetch(`${ajaxApp.homeUrl}?${url}&${params}`, {
    method: 'POST',
  }).then(response => response.text()).then(data => {
    const parser = new DOMParser().parseFromString(data, 'text/html');
    const cart = document.querySelector(cartClass);
    cart.innerHTML = parser.querySelector(cartClass).innerHTML;
    updateCounter(parser);
    pushGtmEvent({
      'event': 'gtm4wp.addToCartEEC',
      'ecommerce': {
        'currencyCode': typeof gtm4wp_currency !== 'undefined' ? gtm4wp_currency : 'AUD',
        'add': {
          'products': [{
            'id': id,
            'quantity': quantity,
          }]
        }
      }
    });
    delay(200).then(openCart)
  }).catch(error => console.error('Error:', error)).finally(() => {
    document.body.classList.remove('is-cart-loading');
  });
}

export { updateCart, addToCart };
